<!--suppress HtmlUnknownTag -->
<template>
  <div>
    <b-field grouped position="is-left" style="align-items: flex-start; padding-top: 10px;">
      <b-button
        v-show="!isActiveTable"
        class="is-success"
        @click="getLead"
        :disabled="!hasModifyPermission">
        EDIT FIRST TOUCH LIST
      </b-button>
    </b-field>
    <span class="settings-text--gray" v-show="!isActiveTable">
      Last updated: {{ lastUpdatedLeadSource.email }}, {{ lastUpdatedLeadSource.paramVal }}
    </span>
    <div class="columns" v-show="isActiveTable">
      <div class="columns-error column is-12">
        <div v-if="errorMessage" class="help is-danger error-table">{{ errorMessage }}</div>
      </div>
    </div>
    <div class="columns" v-show="isActiveTable">
      <div class="column is-9 grid-module__grid">
        <b-table
          hoverable
          sticky-header
          v-slot="leadSourcesTouch"
          class="bordered-table"
          :data="leadSourcesTouch">

          <b-table-column cell-class="cell" width="20" field="ID">
            <b-field>
              <b-checkbox size="is-small" v-model="leadSourcesTouch.row.isShowing"/>
            </b-field>
          </b-table-column>

          <b-table-column cell-class="cell" field="value" label="Name">
            {{ leadSourcesTouch.row.value }}
          </b-table-column>

        </b-table>
      </div>
      <div class="column is-3">
        <b-button outlined size="is-normal"
                  class="fix-size-button"
                  @click.native="onCancel">
          Cancel
        </b-button>
        <b-button size="is-normal" class="fix-size-button is-success"
                  :disabled="!hasModifyPermission"
                  @click.native="onSubmit">
          Submit
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>

import _ from 'lodash';
import { mapGetters } from 'vuex';
import {
  getLeadFirstTouch,
  getLeadFirstTouchLastUpdate,
  postLeadFirstTouch,
} from '@/api/settings';

const TABLE_FIRST_TOUCH = 'TFT';

export default {
  name: 'LeadSourceFirstTouchForm',
  data() {
    return {
      leadSourcesTouch: [],
      initialLeadSourcesTouch: [],
      errorMessage: null,
      canSaveData: true,
      isPreloading: false,
      isActiveTable: false,
      lastUpdatedLeadSource: {
        email: '',
        paramVal: '',
      },
      activeTable: TABLE_FIRST_TOUCH,
    };
  },
  async mounted() {
    this.getLeadSourceLastUpdate();
  },
  computed: {
    ...mapGetters(['hasAccess']),
    hasModifyPermission() {
      const permission = { resource: 'manage-settings', code: 'modify' };
      return this.hasAccess(permission, permission, true);
    },
  },
  watch: {
    leadSourcesTouch: {
      deep: true,
      handler() {
        // eslint-disable-next-line
        const hasChange = this.leadSourcesTouch.some((item, index) => item.isShowing !== this.initialLeadSourcesTouch[index]);
        // eslint-disable-next-line
        const allFalse = this.leadSourcesTouch.every(item => !item.isShowing);
        this.canSaveData = !hasChange || allFalse;
        if (allFalse !== true) {
          this.errorMessage = false;
        }
        // if (allFalse === true) {
        //   this.errorMessage = 'At least one item must be selected';
        // } else {
        //   this.errorMessage = false;
        // }
      },
    },
  },
  methods: {
    toast(message, type = 'is-success') {
      this.$buefy.toast.open({ message, type, duration: 5000 });
    },
    async getLeadSourceLastUpdate() {
      const { data } = await getLeadFirstTouchLastUpdate();
      this.lastUpdatedLeadSource = _.get(data, 'data.0', 'Invalid Response');
    },
    async getLead() {
      this.isActiveTable = true;
      this.isPreloading = true;
      // Load data
      const { data: { data: leadSourcesTouchData } } = await getLeadFirstTouch();
      this.leadSourcesTouch = leadSourcesTouchData;
      this.initialLeadSourcesTouch = this.leadSourcesTouch.map((item) => (item.isShowing));
      this.isPreloading = false;
    },
    onCancel() {
      this.isActiveTable = false;
    },
    /**
     * TODO: data should be copied when component has mounted
     */
    onSubmit() {
      const allFalse = this.leadSourcesTouch.every((item) => !item.isShowing);
      // this.canSaveData = !hasChange || allFalse;
      if (allFalse === true) {
        this.errorMessage = 'At least one item must be selected';
      } else {
        this.errorMessage = false;
        this.onLeadFirstTouchSubmit();
      }
    },
    async onLeadFirstTouchSubmit() {
      this.isPreloading = true;
      try {
        const { data } = await postLeadFirstTouch(this.leadSourcesTouch, true);
        if ('error' in data) {
          this.toast(_.get(data, 'error'), 'is-danger');
        } else if (_.some(data, (row) => _.get(row, 'double', false))) {
          this.leadSourcesTouch = data;
        }
        const responseLastUpdate = await getLeadFirstTouchLastUpdate();
        this.lastUpdatedLeadSource = _.get(responseLastUpdate, 'data.data.0');
      } catch (e) {
        this.toast('Something wrong', 'is-danger');
      } finally {
        this.isPreloading = false;
        this.isActiveTable = false;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.columns-error
  height 10px
  padding-top 0
.bordered-table
  td:first-child
    border-left 1px solid rgba(143, 167, 179, 0.3)
  td:last-child
    border-right 1px solid rgba(143, 167, 179, 0.3)
.cell
  white-space inherit
.fix-size-button
  width 80px
  margin-bottom 8px
  margin-right 8px
</style>
